export class BaseModel {
  [key: string]: any;

  constructor(data?: any) {
    if (data) {
      this.setAttributes(data);
    }
  }

  get childModels(): { [key: string]: any } {
    return {};
  }

  protected setAttributes(data: any): void {
    Object.assign(this, data);

    for (const key of Object.keys(this.childModels)) {
      const Model = this.childModels[key];
      const value = data[key];

      if (value === undefined || value === null) {
        continue;
      }

      if (Array.isArray(value)) {
        this[key] = value.map(v => new Model(v));
      } else {
        this[key] = new Model(value);
      }
    }
  }
}
